import React from "react";
import { Card } from "react-bootstrap";
import "./PravnoLiceCard.scss";
import Button from "../components/Button";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Cookies from "universal-cookie";
import config from "../config.json";

function SaradnjaPonude({ datum, naziv, kontakt, cijena, key, id }) {
  const cookies = new Cookies();
  const user = cookies.get("fizickoLice");
  const navigate = useNavigate();
  const { baseUrl, token } = config;

  async function finishOffer(accepted) {
    await axios.post(
      `${baseUrl}/fizicko/zavrsi-ponudu`,
      {
        korisnickoIme: user.korisnickoIme,
        pravnoLice: naziv,
        accepted,
        offer: id,
      },
      {
        headers: {
          token: token,
          "Content-Type": "application/json",
        },
      }
    );

    navigate("/");
  }
  return (
    <>
      <Card className="card-saradnja-ponude">
        <Card.Body>
          <Card.Text>
            Datum: {datum} <br />
            Ime pravnog lica: {naziv} <br />
            Kontakt telefon: {kontakt} <br />
            Cijena: {cijena} KM <br />
            <br></br>
            <Link
              id="prikaziVise"
              to={`/prihvatanje-ponude-fizickog-lica/${id}`}
            >
              PRIKAŽI VIŠE
            </Link>
            <Button
              value="PRIHVATI"
              marginTop="1rem"
              marginBottom="1rem"
              marginLeft="0rem"
              marginRight="0rem"
              onClick={() => finishOffer(true)}
            />
            <Button
              value="ODBIJ"
              type="danger"
              onClick={() => finishOffer("false")}
            />
          </Card.Text>
        </Card.Body>
      </Card>
    </>
  );
}

export default SaradnjaPonude;
